import React, { useState, useEffect } from 'react';
import { ModalDialog } from '../../Modal';
import { TextField, Grid, InputBase, InputLabel } from '@material-ui/core';
import Password from '../../Password';
import StyledInputWrapper from './style';
import { validateField } from '../../../validations/Rules';
import { updateEmail } from '../../../stores/api';
import { toast } from "react-toastify";

const AccountEditEmailModal = ({ open, onClose, onOk, currentEmail }) => {
  const [newEmail, setNewEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleValidate = (field, value, rules) => {
    let error = null;
    for (const rule of rules) {
      const validationError = validateField(rule, field, value);
      if (validationError) {
        error = validationError[0];
        break;
      }
    }

    setErrors(prev => ({
      ...prev,
      [field]: error ? [error] : undefined
    }));

    return error;
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setNewEmail(value);
    handleValidate('email', value, ['required', 'email']);
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    handleValidate('password', value, ['required']);
  };

  const validateAllFields = () => {
    const emailError = handleValidate('email', newEmail, ['required', 'email']);
    const passwordError = handleValidate('password', password, ['required']);

    return !emailError && !passwordError;
  };

  const handleOk = async () => {
    if (newEmail === currentEmail) {
      onClose();
      return;
    }

    if (!validateAllFields()) {
      return;
    }

    try {
      setLoading(true);
      const response = await updateEmail({ email: newEmail, auth_password: password });
      if (response.status === 200) {
        toast.success('Email updated successfully!');
        onOk(newEmail);
      } else {
        toast.error('Failed to update email');
      }
    } catch (error) {
      setErrors({ password: [error.message] });
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    if (open) {
      setNewEmail('');
      setPassword('');
      setErrors({});
    }
  }, [open]);

  return <ModalDialog
    open={open}
    onClose={onClose}
    onOk={handleOk}
    title="Edit Email"
    loading={loading}
  >
    <Grid container spacing={2}>
      <StyledInputWrapper item xs={12}>
        <InputLabel size='small'>Current Email</InputLabel>
        <TextField
          value={currentEmail}
          name={`currentEmail`}
          type={`text`}
          disabled
          variant="outlined"
          fullWidth={true}
          size='small'
        />
      </StyledInputWrapper>
      <StyledInputWrapper item xs={12}>
        <InputLabel required={true} size='small'>New Email</InputLabel>
        <TextField
          value={newEmail}
          onChange={handleEmailChange}
          name={`newEmail`}
          type={`email`}
          variant="outlined"
          fullWidth={true}
          size='small'
          error={errors?.email?.length > 0}
          helperText={errors?.email?.[0]}
        />
      </StyledInputWrapper>
      <Grid item xs={12}>
        <Password
          value={password}
          onChange={handlePasswordChange}
          label="Your Password"
          placeholder=""
          required={true}
          showLabel={true}
          error={errors?.password?.length > 0}
          helperText={errors?.password?.[0]}
        />
      </Grid>
    </Grid>
  </ModalDialog>
};

export default AccountEditEmailModal;